import React from "react"
import moment from "moment"
import {
  Page,
  Text,
  View,
  Document,
  Font,
  Image,
  StyleSheet
} from "@react-pdf/renderer"

const PrintOrderPDF = (props) => {
  const orderDetailItem = (index, detail) => {
    return (
      <View key={detail.id} style={[styles.row]}>
        <Text
          style={[
            styles.headerText,
            styles.cell,
            styles.text,
            { width: "5px" }
          ]}
        >
          {index + 1}
        </Text>
        <Text
          style={[
            styles.headerText,
            styles.cell,
            styles.text,
            { width: "40px", justifyContent: "flex-start" }
          ]}
        >
          {detail.product.productNumber}
        </Text>
        <Text
          style={[
            styles.headerText,
            styles.cell,
            styles.text,
            { width: "300px", paddingRight: "10px" }
          ]}
        >
          {detail.product.description}
        </Text>
        <Text
          style={[
            styles.headerText,
            styles.cell,
            styles.text,
            { width: "5px", textAlign: "center" }
          ]}
        >
          {detail.quantity}
        </Text>
        <Text
          style={[
            styles.headerText,
            styles.cell,
            styles.text,
            { width: "10px", textAlign: "center" }
          ]}
        >
          ${formatNumber(detail.unitPrice)}
        </Text>
        <Text
          style={[
            styles.headerText,
            styles.cell,
            styles.text,
            { width: "10px", textAlign: "center" }
          ]}
        >
          ${formatNumber(detail.sum)}
        </Text>
      </View>
    )
  }

  const formatNumber = (n) => {
    n += ""
    const arr = n.split(".")
    const re = /(\d{1,3})(?=(\d{3})+$)/g
    return arr[0].replace(re, "$1,") + (arr.length === 2 ? `.${arr[1]}` : "")
  }

  const roundedTax = (order) => {
    return Math.round(order.totalAmount * 0.05)
  }

  if (!props.order) {
    return (
      <Document>
        <Page style={styles.page} size="A4" wrap>
          <Text style={styles.title}>巨研科技股份有限公司</Text>
        </Page>
      </Document>
    )
  }

  const { order } = props

  return (
    <Document title={order.orderNumber}>
      <Page style={styles.page} size="A4" wrap>
        <Text style={styles.title}>巨研科技股份有限公司</Text>
        <Text style={styles.author}>
          總公司：813 高雄市左營區裕誠路392號14樓 統一編號：16729477
        </Text>
        <Text style={styles.author}>
          高雄專線：07-5507380 台中專線：04-23551040 台北專線：02-29457272
        </Text>
        <Text style={styles.author}>免付費電話：0800-802-206</Text>
        <View style={[styles.row, { justifyContent: "space-around" }]}>
          <Text style={styles.subtitle}>報價憑單</Text>
        </View>

        {/*  --------- 訂單基本資料 --------- */}
        <View style={styles.table}>
          <View style={[styles.row]}>
            <Text style={[styles.headerText, styles.cell, styles.text]}>
              {`報價單號: ${order.orderNumber}`}
            </Text>
            <Text style={[styles.headerText, styles.cell, styles.text]}>
              {`報價日期: ${moment(order.submittedTime).format("YYYY/MM/DD")}`}
            </Text>
            <Text style={[styles.headerText, styles.cell, styles.text]}>
              {`列印日期: ${moment().format("YYYY/MM/DD")}`}
            </Text>
          </View>
          <View style={[styles.row]}>
            <Text style={[styles.headerText, styles.cell, styles.text]}>
              {`客戶名稱: ${order.company.name}`}
            </Text>
            <Text style={[styles.headerText, styles.cell, styles.text]}>
              {`統一編號: ${order.company.companyNumber}`}
            </Text>
            <Text style={[styles.headerText, styles.cell, styles.text]}></Text>
          </View>
          <View style={[styles.row]}>
            <Text style={[styles.headerText, styles.cell, styles.text]}>
              {`訂單建立人員: ${order.user.name}`}
            </Text>
            <Text style={[styles.headerText, styles.cell, styles.text]}>
              {`聯絡電話: ${order.company.phoneNumber}`}
            </Text>
            <Text style={[styles.headerText, styles.cell, styles.text]}></Text>
          </View>
        </View>
        {/*  --------- 幣別 --------- */}
        <View style={[styles.table]}>
          <View style={[styles.row]}>
            <Text style={[styles.headerText, styles.cell, styles.text]}>
              {"幣別: NTD (台幣)"}
            </Text>
            <Text style={[styles.headerText, styles.cell, styles.text]}>
              {"產品單價: 未稅"}
            </Text>
            <Text style={[styles.headerText, styles.cell, styles.text]}></Text>
          </View>
        </View>
        {/*  --------- 產品清單標頭 --------- */}
        <View style={styles.table}>
          <View
            style={[
              styles.row,
              {
                borderBottom: "1",
                borderTop: "1",
                borderColor: "gray",
                paddingTop: "5px",
                paddingBottom: "5px"
              }
            ]}
          >
            <Text
              style={[
                styles.headerText,
                styles.cell,
                styles.text,
                { width: "5px" }
              ]}
            >
              欄號
            </Text>
            <Text
              style={[
                styles.headerText,
                styles.cell,
                styles.text,
                { width: "40px" }
              ]}
            >
              產品編號
            </Text>
            <Text
              style={[
                styles.headerText,
                styles.cell,
                styles.text,
                { width: "300px" }
              ]}
            >
              產品規格 / 產品說明
            </Text>
            <Text
              style={[
                styles.headerText,
                styles.cell,
                styles.text,
                { width: "5px", textAlign: "center" }
              ]}
            >
              數量
            </Text>
            <Text
              style={[
                styles.headerText,
                styles.cell,
                styles.text,
                { width: "10px", textAlign: "center" }
              ]}
            >
              單價
            </Text>
            <Text
              style={[
                styles.headerText,
                styles.cell,
                styles.text,
                { width: "10px", textAlign: "center" }
              ]}
            >
              金額
            </Text>
          </View>
        </View>
        {/*  --------- 產品清單 --------- */}
        <View style={styles.table}>
          {order.orderDetails.map((detail, index) => {
            return orderDetailItem(index, detail)
          })}
        </View>
        {/*  --------- 小計區塊 --------- */}
        <View wrap={false} style={styles.table}>
          <View
            style={[
              styles.row,
              {
                justifyContent: "flex-end",
                paddingRight: 0,
                marginRight: 0
              }
            ]}
          >
            <View style={{ width: 60 }}>
              <Text style={[styles.headerText, styles.cell, styles.text]}>
                {`合計: $${formatNumber(order.totalAmount) || 0}`}
              </Text>
              <Text style={[styles.headerText, styles.cell, styles.text]}>
                {`稅金: $${formatNumber(roundedTax(order))}`}
              </Text>
              <Text style={[styles.headerText, styles.cell, styles.text]}>
                {`總計: $${formatNumber(
                  order.totalAmount + roundedTax(order)
                )}`}
              </Text>
            </View>
          </View>
        </View>
        {/*  --------- 說明區塊 --------- */}
        <View wrap={false} style={styles.table}>
          <View
            style={[
              styles.row,
              {
                marginBottom: "10px",
                paddingTop: "10px",
                paddingRight: "10px",
                borderTop: "1",
                borderColor: "gray",
                display: "flex",
                flexWrap: "wrap"
              }
            ]}
          >
            <Text style={[styles.headerText, styles.cell, styles.text]}>
              {
                "※ 配合政府節能減碳及推動電子發票政策，本公司將於民國107年5月1日起，停止使用電子計算機統一發票，\n轉為開立電子發票，特此通知。"
              }
            </Text>
          </View>
          <View style={[styles.row, { marginBottom: "10px" }]}>
            <Text style={[styles.headerText, styles.cell, styles.text]}>
              {"※ 交易金額未滿新台幣壹仟元者需加運費新台幣壹佰元整"}
            </Text>
          </View>
          <View style={[styles.row, { marginBottom: "10px" }]}>
            <Text style={[styles.headerText, styles.cell, styles.text]}>
              {"備註："}
            </Text>
          </View>
          <View style={[styles.row]}>
            <Text style={[styles.headerText, styles.cell, styles.text]}>
              {
                "1. 交貨約定：回傳本報價單或貴單位訂購單據至( )高雄Fax 07-5507480 或 ( )台北Fax 02-29458181"
              }
            </Text>
          </View>
          <View style={[styles.row]}>
            <Text style={[styles.headerText, styles.cell, styles.text]}>
              {
                "2. 其它約定條款：本報價單所示價格不含安裝與測試費用；如若須要，則另行收費"
              }
            </Text>
          </View>
          <View style={[styles.row]}>
            <Text style={[styles.headerText, styles.cell, styles.text]}>
              {"3. 收件人：                   電話：                   傳真："}
            </Text>
          </View>
          <View style={[styles.row]}>
            <Text style={[styles.headerText, styles.cell, styles.text]}>
              {"交貨地點："}
            </Text>
          </View>
        </View>
        {/*  ---------簽名區塊 --------- */}
        <View wrap={false} style={styles.table}>
          <View style={[styles.row, { marginBottom: "40px" }]}>
            <Text style={[styles.headerText, styles.cell, styles.text]}>
              {""}
            </Text>
          </View>
          <View style={{ display: "flex" }}>
            <Image
              style={[styles.image, { width: "120px" }]}
              src="/stamp.jpg"
            />
          </View>
          <View style={[styles.row, { justifyContent: "flex-left" }]}>
            <Text
              style={[
                styles.headerText,
                styles.cell,
                styles.text,
                {
                  flexGrow: "0",
                  borderTop: "1",
                  borderColor: "black",
                  paddingTop: "10px",
                  width: "150px"
                }
              ]}
            >
              {"巨研科技股份有限公司  簽章"}
            </Text>
            <Text
              style={[
                styles.headerText,
                styles.cell,
                styles.text,
                {
                  marginLeft: "30px",
                  flexGrow: "0",
                  borderTop: "1",
                  borderColor: "black",
                  paddingTop: "10px",
                  width: "150px"
                }
              ]}
            >
              {"客戶  簽章"}
            </Text>
          </View>
        </View>
        <Text
          style={styles.pageNumber}
          render={({ pageNumber, totalPages }) =>
            `${pageNumber} / ${totalPages}`
          }
          fixed
        />
      </Page>
    </Document>
  )
}

Font.register({
  family: "NotoSansTC",
  fonts: [{ src: "/mingliu.ttf" }]
})

const styles = StyleSheet.create({
  image: {
    marginVertical: 15
  },
  page: {
    paddingTop: 25,
    paddingBottom: 45,
    paddingHorizontal: 35,
    flexDirection: "column"
  },
  table: {
    fontSize: 10,
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignContent: "stretch",
    flexWrap: "nowrap",
    alignItems: "stretch",
    marginBottom: 10
  },
  row: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-around",
    alignContent: "stretch",
    flexWrap: "nowrap",
    alignItems: "stretch",
    flexGrow: 0,
    flexShrink: 0,
    flexBasis: 35
  },
  cell: {
    flexGrow: 1,
    flexShrink: 1,
    flexBasis: "auto",
    alignSelf: "stretch"
  },
  title: {
    fontSize: 16,
    textAlign: "left",
    fontFamily: "NotoSansTC",
    marginBottom: 10
  },
  author: {
    fontSize: 10,
    textAlign: "left",
    fontFamily: "NotoSansTC"
  },
  subtitle: {
    fontSize: 12,
    fontFamily: "NotoSansTC",
    marginTop: 10,
    marginBottom: 10,
    paddingBottom: 5,
    borderBottom: "1",
    borderColor: "gray",
    justifyContent: "center"
  },
  text: {
    fontSize: 10,
    textAlign: "justify",
    fontFamily: "NotoSansTC",
    width: "100px"
  },
  line: {
    display: "flex",
    flexWrap: "nowrap"
  },
  header: {
    fontSize: 12,
    textAlign: "center"
  },
  headerText: {
    fontSize: 11,
    fontWeight: 1200
  },
  tableText: {
    fontSize: 10
  },
  pageNumber: {
    position: "absolute",
    fontSize: 12,
    bottom: 30,
    left: 0,
    right: 0,
    textAlign: "center",
    color: "grey"
  }
})

export default PrintOrderPDF
